export function shorten(str: string, maxLength: number): string {
  if (str.length > maxLength) {
    return str.substr(0, maxLength - 3) + '...'
  }
  return str
}
